var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".75vw",
    height: ".65vw",
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84955 8.51116L4.77853 12.0615L0.299566 9.34749L1.32716 6.22067L4.84955 8.51116ZM5.26031 7.99394L1.60333 5.74434L9.75916 0.793241L13.577 3.15704L13.4572 3.22671L13.4313 3.18393L5.26031 7.99394ZM10.8368 5.3952L13.7944 3.61154L14.6995 6.33874L5.31057 12.0305L5.59984 8.66895L10.8368 5.3952Z",
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowGold);
export default __webpack_public_path__ + "static/media/yellow_gold.a18d69c38067e6491e5da1408d98a2fe.svg";
export { ForwardRef as ReactComponent };